module.exports = __webpack_public_path__ + "img/qc.53cc6304.gif";